/* ============================================================
   FlickerBet — Navigation
   ============================================================ */ (function() {
    'use strict';
    const nav = document.getElementById('main-nav');
    const toggle = document.getElementById('nav-toggle');
    const menu = document.getElementById('nav-menu');
    if (!nav || !toggle || !menu) return;
    // ── Scroll: add .scrolled class ──
    function onScroll() {
        if (window.scrollY > 20) nav.classList.add('scrolled');
        else nav.classList.remove('scrolled');
    }
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    onScroll();
    // ── Hamburger toggle ──
    toggle.addEventListener('click', function() {
        const isOpen = menu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // ── Close on nav link click ──
    menu.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', function() {
            menu.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });
    });
    // ── Close on outside click ──
    document.addEventListener('click', function(e) {
        if (menu.classList.contains('open') && !menu.contains(e.target) && !toggle.contains(e.target)) {
            menu.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        }
    });
    // ── Active link highlight on scroll ──
    const sections = document.querySelectorAll('section[id]');
    const navLinks = menu.querySelectorAll('a[href^="#"]');
    function highlightNav() {
        let current = '';
        sections.forEach(function(section) {
            if (window.scrollY >= section.offsetTop - 120) current = section.getAttribute('id');
        });
        navLinks.forEach(function(link) {
            link.classList.remove('active');
            if (link.getAttribute('href') === '#' + current) link.classList.add('active');
        });
    }
    window.addEventListener('scroll', highlightNav, {
        passive: true
    });
})();

//# sourceMappingURL=project-6a06e5c63dd06d7c7d8222d4.96518d46.js.map
